import React from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Divider,
  IconButton,
  ListItemText,
  Tooltip,
  MenuItem,
  MenuList,
  Popper,
  Paper,
  Grow,
  ClickAwayListener
} from '@material-ui/core';
import { Sort, Check } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  button: {
    margin: '8px'
  },
  selected: {
    boxShadow: '0 0 0 1px rgb(63 63 68 / 5%), 0 1px 3px 0 rgb(63 63 68 / 15%)',
    color: theme.palette.primary.main,
    margin: '8px'
  }
}));

export default function SortButton(props) {
  const classes = useStyles();
  const { options, onChangeSortOption, sortTypes, onChangeSortType } = props;

  const [sortOptions, setSortOptions] = React.useState(options || []);
  const [sortableTypes, setSortableTypes] = React.useState(sortTypes || []);
  const [isSelected, setIsSelected] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  React.useEffect(() => {
    setSortOptions(options);
    if (
      getCheckedOptionsLength(options) > 0 &&
      getCheckedOptionsLength(sortTypes) <= 0
    ) {
      let types = sortTypes.map(option => {
        if (option.name === 'ASC') {
          return { ...option, checked: true };
        } else {
          return option;
        }
      });
      setSortableTypes(types);
    } else {
      setSortableTypes(sortTypes);
    }
    setIsSelected(getCheckedOptionsLength(options) > 0);
  }, [options, sortTypes]);

  const getCheckedOptionsLength = options => {
    return options.filter(option => option.checked).length;
  };

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleOptionChange = option => {
    let options = sortOptions.map(sortOption => {
      if (option.name === sortOption.name) {
        return { ...sortOption, checked: !sortOption.checked };
      } else {
        return { ...sortOption, checked: false };
      }
    });
    setSortOptions(options);
    if (onChangeSortOption && typeof onChangeSortOption === 'function') {
      onChangeSortOption(options);
    }
  };

  const handleTypeChange = option => {
    let types = sortableTypes.map(type => {
      if (option.name === type.name) {
        return { ...type, checked: !type.checked };
      } else {
        return { ...type, checked: false };
      }
    });
    setSortableTypes(types);
    if (onChangeSortType && typeof onChangeSortType === 'function') {
      onChangeSortType(types);
    }
  };

  return (
    <>
      <Tooltip title="Sort by">
        <IconButton
          className={isSelected ? classes.selected : classes.button}
          aria-label="sort by"
          ref={anchorRef}
          onClick={handleToggle}>
          <Sort />
        </IconButton>
      </Tooltip>
      <Popper
        placement="bottom-start"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom'
            }}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu">
                  {sortOptions.map((option, index) => (
                    <MenuItem
                      key={option.name + index}
                      onClick={() => handleOptionChange(option)}>
                      {option.checked ? (
                        <Check />
                      ) : (
                        <div style={{ paddingLeft: '24px' }} />
                      )}
                      <ListItemText style={{ paddingLeft: '6px' }}>
                        {option.value}
                      </ListItemText>
                    </MenuItem>
                  ))}
                  <Divider />
                  {sortableTypes.map((option, index) => (
                    <MenuItem
                      key={option.name + index}
                      onClick={() => handleTypeChange(option)}
                      disabled={getCheckedOptionsLength(sortOptions) <= 0}>
                      {getCheckedOptionsLength(sortOptions) > 0 &&
                      option.checked ? (
                        <Check />
                      ) : (
                        <div style={{ paddingLeft: '24px' }} />
                      )}
                      <ListItemText style={{ paddingLeft: '6px' }}>
                        {option.value}
                      </ListItemText>
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
